'use strict';

/* global yith_wcaf */

import YITH_WCAF_Admin_Table from './yith-wcaf-admin-table.js';
import YITH_WCAF_Edit_Gateway_Modal from './yith-wcaf-edit-gateway-modal.js';
import { $ } from '../../../src/globals.js';

export default class YITH_WCAF_Gateways_Table extends YITH_WCAF_Admin_Table {
	constructor( $context, args ) {
		super( $context, {
			action_suffix: '_gateway',
			nonce_suffix: '_gateway',
			data: ( $row ) => {
				return {
					gateway_id: $row.data( 'id' ),
				};
			},
			...args,
		} );
	}

	// modal
	modal = null;

	init() {
		this.initModal();
		this.initEnableButtons();
	}

	initEnableButtons() {
		const self = this;

		this.$context.on(
			'change',
			'.enabled input[type="checkbox"]',
			function ( ev ) {
				ev.preventDefault();

				const $field = $( this ),
					action = $field.is( ':checked' ) ? 'enable' : 'disable';

				self.doButtonAction( action, $field );
			}
		);
	}

	initModal() {
		const $openers = this.getModalOpeners();

		if ( $openers.length ) {
			this.modal = new YITH_WCAF_Edit_Gateway_Modal( $openers );
		}
	}

	getModalOpeners() {
		return $( '.edit', this.$table );
	}
}
